// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"index_wrapper_2xrsu","messagesWrapper":"index_messagesWrapper_1UOwP","messages":"index_messages_1SU1k"};